module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "form-group d-flex"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', [_vm._v("Name")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.origin.name),
      expression: "origin.name"
    }],
    staticClass: "w-50",
    attrs: {
      "type": "text",
      "placeholder": "Name here"
    },
    domProps: {
      "value": (_vm.origin.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.origin, "name", $event.target.value)
      }
    }
  })])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-646c36d4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-646c36d4"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/origins/originsForm.vue
// module id = 2341
// module chunks = 0